export default "https://cdn-static.gokick.com/assets/b4d66d8cd7eb0aaa0b454a3d41ce872cff261527/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";